import axios from 'axios';
import { API_CONFIG } from '../config/api.config';

// Definir la interfaz para el servicio
export interface ServiceDefinition {
  id: string;
  name: string;
  subcategoryId: string;
  // Otros campos que pueda tener el servicio
}

// Servicio para manejar las operaciones relacionadas con servicios
export const ServiceDefinitionService = {
  // Obtener servicios por subcategoría
  getServicesBySubcategory: async (subcategoryId: string): Promise<ServiceDefinition[]> => {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}api/servicedefinitions/by-subcategory/${subcategoryId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default ServiceDefinitionService;
